import { SquareIcon } from "lucide-react";

import BasePreview from "@/components/builder/blocks/base";
import { prop, define } from "@/components/builder/utils";

import { DroppablePlaceholder } from "../utils/Placeholder";

function ContainerPreview({ children, properties: { maxWidth, ...properties }, ...props }) {
  children = children || <DroppablePlaceholder>
    Drop here
  </DroppablePlaceholder>

  return <BasePreview className={maxWidth} properties={properties} {...props}>
    <div>
      {children}
    </div>
  </BasePreview>
}

export default define('container', ContainerPreview)
  .canvas()
  .palete(<SquareIcon size={16} />, 'Container', 'Structures')
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.layout())
  .property(...prop.predefined.container())
  .property(prop.group('Max Width', 'maxWidth').unique()
    .category('default')
    .options(prop.options()
      .add('None', 'container')
      .add('Full', 'container max-w-full')
      .add('10 Extra Large', 'container max-w-[110rem]')
      .add('9 Extra Large', 'container max-w-[100rem]')
      .add('8 Extra Large', 'container max-w-[90rem]')
      .add('7 Extra Large', 'container max-w-7xl')
      .add('6 Extra Large', 'container max-w-6xl')
      .add('5 Extra Large', 'container max-w-5xl')
      .add('4 Extra Large', 'container max-w-4xl')
      .add('3 Extra Large', 'container max-w-3xl')
      .add('2 Extra Large', 'container max-w-2xl')
      .add('Extra Large', 'container max-w-xl')
      .add('Large', 'container max-w-lg')
      .add('Medium', 'container max-w-md')
      .add('3 Extra Small', 'container max-w-3xs')
      .add('2 Extra Small', 'container max-w-2xs')
      .add('Extra Small', 'container max-w-xs')
      .add('Small', 'container max-w-sm'),
    ))
  .property(prop.predefined.attributes())
  .defaultProps({
    maxWidth: 'container',
  })
  .build()
